(() => {
  function getVariantMaxMap(scope) {
    const json = scope.querySelector('[data-variant-max-qty-json]');
    if (!json) return {};

    try {
      return JSON.parse(json.textContent);
    } catch (e) {
      return {};
    }
  }

  function applyMaxQty(form) {
    const idInput = form.querySelector('input[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');

    if (!idInput || !qtyInput) return;

    const scope = form.closest('.product') || document;
    const maxMap = getVariantMaxMap(scope);
    const maxQty = parseInt(maxMap[idInput.value], 10);

    let note = form.querySelector('[data-max-order-quantity-note]');

    if (!maxQty || maxQty <= 0) {
      qtyInput.removeAttribute('max');
      if (note) note.remove();
      return;
    }

    qtyInput.setAttribute('max', maxQty);

    if (parseInt(qtyInput.value || '1', 10) > maxQty) {
      qtyInput.value = maxQty;
    }

    if (!note) {
      note = document.createElement('p');
      note.dataset.maxOrderQuantityNote = '';
      note.className = 'product-info__max-order-note text-sm mt-2';
      form.querySelector('.product-info__add-to-cart')?.after(note);
    }

    note.textContent = `Max. ${maxQty} Stück pro Bestellung.`;
  }

  function initProductForms() {
    document.querySelectorAll('form.js-product-form').forEach((form) => {
      applyMaxQty(form);

      form.addEventListener('change', () => {
        setTimeout(() => applyMaxQty(form), 50);
      });

      form.addEventListener('submit', (event) => {
        applyMaxQty(form);

        const qtyInput = form.querySelector('input[name="quantity"]');
        const maxQty = qtyInput ? parseInt(qtyInput.getAttribute('max'), 10) : 0;

        if (qtyInput && maxQty > 0 && parseInt(qtyInput.value, 10) > maxQty) {
          event.preventDefault();
          qtyInput.value = maxQty;
          alert(`Für diese Variante sind maximal ${maxQty} Stück bestellbar.`);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initProductForms);
  document.addEventListener('shopify:section:load', initProductForms);
})();